module.exports = __webpack_public_path__ + "img/xuesheng.115ff275.png";